import React, { Component } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";

import Inputs from "./Inputs";
import CodebookMenu from "./CodebookMenu";
import DiscardReasonModal from "../DiscardReasonModal";

import discard from "@safecv/assets/Images/discard.svg";
import restore from "@safecv/assets/Images/restore.svg";
import info from "@safecv/assets/Images/discard_info.svg";
import needsInput from "@safecv/assets/Images/needs_input.svg";

import "./CriteriaView.css";

const HtmlTooltipInfo = withStyles(() => ({
  tooltip: {
    backgroundColor: "white",
    minHeight: "10px",
    width: "240px",
    padding: 0,
    top: "-0.7rem",
    marginLeft: "32%",
    overflow: "hidden",
    borderRadius: "5px",
    boxSizing: "border-box",
    boxShadow: "0px 0px 34px rgba(0, 0, 0, 0.15)",
  },
  arrow: {
    color: "#ffffff",
  },
}))(Tooltip);

const modal = (
  id,
  information,
  notes,
  handleOpen,
  handleClose,
  handleDiscardAnnotation,
  handleDiscardAnnotationWrapper,
  isModalOpen,
  annotationName,
  isDiscardedOpen,
  planStatus,
  handleRestoreAnnotation,
  setSelectedAnnotationUuid
) => {
  return (
    <div>
      {/* <div
        className="info-icon-button"
        style={{ visibility: isDiscardedOpen ? "visible" : "hidden" }}
      >
        <HtmlTooltipInfo
          arrow
          placement="right-start"
          PopperProps={{
            disablePortal: true,
            popperOptions: {
              positionFixed: true,
              modifiers: {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: "window", // where "window" is the boundary
                },
              },
            },
          }}
          title={
            <>
              <div className="tooltip-info-header">Discard Reason</div>
              <div className="tooltip-info-content-details">{notes}</div>
            </>
          }
        >
          <img src={info} alt="info" />
        </HtmlTooltipInfo>
      </div> */}
      <div
        className="codebook-annotation-button"
        style={{ visibility: !_.isEmpty(information) ? "visible" : "hidden" }}
      >
        <CodebookMenu information={information} />
      </div>

      {isDiscardedOpen ? (
        <div>
          <div
            className="discard-annotation-button"
            style={{
              visibility:
                planStatus.toLowerCase() === "verify" ? "visible" : "hidden",
            }}
          >
            <img
              src={restore}
              alt="Restore"
              onClick={() => handleRestoreAnnotation(id)}
            />
          </div>
          <div className="discard-text-box">
            <span className="discard-text"> Restore </span>
          </div>
        </div>
      ) : (
        <div>
          <div
            className="discard-annotation-button"
            style={{
              visibility:
                planStatus.toLowerCase() === "verify" ? "visible" : "hidden",
            }}
            // onClick={() => handleOpen(id)}
            onClick={() => handleDiscardAnnotationWrapper('', '', id)}
          >
            <img src={discard} alt="Discard" />
          </div>
          <div className="discard-text-box">
            <span className="discard-text"> Discard </span>
          </div>
        </div>
      )}
      {/* <DiscardReasonModal
        isModalOpen={isModalOpen}
        handleClose={handleClose}
        annotationName={annotationName}
        handleDiscardAnnotation={handleDiscardAnnotation}
        setSelectedAnnotationUuid={setSelectedAnnotationUuid}
      /> */}
    </div>
  );
};

class CriteriaView extends Component {
  state = {
    isModalOpen: false,
    annotationId: null,
    isNeedsInputOpen: false,
  };

  handleClose = () => {
    this.setState({
      annotationId: null,
      isModalOpen: false,
    });
  };

  handleOpen = (id) => {
    this.setState({
      isModalOpen: true,
      annotationId: id,
    });
  };

  handleRestoreAnnotation = (annotationId) => {
    const { viewType, jobId, discardRestoreAnnotation } = this.props;
    discardRestoreAnnotation(jobId, annotationId, viewType, false, "");
    this.props.setRestoredAnnotationId(annotationId);
  };

  handleDiscardAnnotationWrapper = (textvalue, selectedValue, annotationId) => {
    this.setState({
      annotationId, 
    }, () => {
      this.handleDiscardAnnotation(textvalue, selectedValue)
    })
  }

  handleDiscardAnnotation = (textvalue, selectedValue) => {
    const { annotationId } = this.state;
    const { viewType, jobId, discardRestoreAnnotation } = this.props;
    discardRestoreAnnotation(
      jobId,
      annotationId,
      viewType,
      true,
      selectedValue === "None of the above" ? textvalue : selectedValue
    );
    this.handleClose();
  };

  handleReadMessage = () => {
    this.props.readAnnotationMessage(
      this.props.jobId,
      this.props.annotationId,
      this.props.viewType,
      true
    );
  };

  handleUpdateNeedsInput = () => {
    this.setState({ isNeedsInputOpen: false });
  };

  render() {
    let props = this.props;
    let { isModalOpen, isNeedsInputOpen } = this.state;
    let annotation = props.annotation;
    let message = annotation.annotationSpecificMessage;
    let read = annotation.read;
    let groupName = "Page ";
    let groupBy = "pageNo";

    //Hardcoded logic for switching. This is bad.
    if (props.groupBy === "pageNo" && annotation.ruleNo) {
      groupName = "Rule ";
      groupBy = "ruleNo";
    }
    return (
      <>
        <div
          className="annotation-wrapper"
          ref={props.annotationRefs[annotation.annotationName]}
        >
          <div
            className={`showbox
              ${
                annotation.annotationName === props.selectedAnnotation
                  ? "showbox-active"
                  : ""
              } ${
              annotation?.resourceType === "compliance" ||
              annotation?.resourceType === "violation"
                ? "compliance-showbox"
                : ""
            }`}
            key={annotation.id}
            id={annotation.id}
            onClick={() => {
              props.setSelectedAnnotation(null);
              this.setState({ isNeedsInputOpen: true });
              props.setGroupByValue(annotation[props.groupBy]);
              setTimeout(function () {
                props.setSelectedAnnotation(annotation.annotationName);
              }, 0);
              if (!annotation.read) {
                this.handleReadMessage(true);
              }
            }}
          >
            <div className={annotation?.resourceType + "-line"}></div>
            <div
              className={
                annotation?.resourceType === "compliance" ||
                annotation?.resourceType === "violation"
                  ? "annotation-compliance-contents"
                  : ""
              }
            >
              <div className="needs-input-icon-container">
                <div
                  className={`annotation-heading-container annotation-type
                        ${
                          props.viewType?.includes("complaince") || props.viewType?.includes("violation")
                          ? "complaince-heading-container" : ""
                        }
                        ${
                          props.isDiscardedOpen
                            ? "annotation-heading-discarded"
                            : ""
                        }`}
                  title={`${groupName}${annotation[groupBy]}${
                    annotation?.sheetNumber && ` | ${annotation?.sheetNumber}`
                  } | ${annotation?.sheetName} (${annotation?.annotationType})`}
                >
                  <span className={"pageNo"}>
                    {groupName + annotation[groupBy]}
                  </span>
                  {annotation?.sheetNumber && (
                    <span> | {annotation.sheetNumber}</span>
                  )}
                  {annotation?.sheetName && (
                    <span> | {annotation.sheetName}</span>
                  )}
                  {annotation?.annotationType && (
                    <span> ({annotation.annotationType})</span>
                  )}
                </div>
                {props.viewType &&
                  (props.viewType.includes("compliance") ||
                    props.viewType.includes("violation")) &&
                  annotation.needsInput && <img src={needsInput} />}
              </div>
              <div className={read ? "read" : "unread"}>
                {message ? message : "(no text)"}
              </div>
            </div>
          </div>
          {props.viewType === "annotated" &&
            modal(
              annotation.id,
              annotation.information,
              annotation.notes,
              this.handleOpen,
              this.handleClose,
              this.handleDiscardAnnotation,
              this.handleDiscardAnnotationWrapper,
              isModalOpen,
              annotation.annotationName,
              props.isDiscardedOpen,
              props.planStatus,
              this.handleRestoreAnnotation,
              props.setSelectedAnnotationUuid
            )}
        </div>
        {isNeedsInputOpen &&
          (props.viewType.includes("compliance") ||
            props.viewType.includes("violation")) &&
          annotation.annotationName === props.selectedAnnotation &&
          annotation.needsInput && (
            <Inputs
              jobId={props.jobId}
              annotationId={annotation.id}
              input={annotation.needsInput}
              planStatus={props.planStatus}
              setSelectedSearchResult={props.setSelectedSearchResult}
              handleUpdateNeedsInput={this.handleUpdateNeedsInput}
            />
          )}
      </>
    );
  }
}

export default CriteriaView;
